import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User changed a share link design font',
  name: 'share_link_font_updated',
  params: [
    {
      description: 'Name of the font that was applied',
      name: 'font',
      required: true,
      type: 'string',
    },
    {
      description: 'True when the font came from applying a brand context, false when it was picked by hand',
      name: 'from_brand_context',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
